import { Button, Divider, Grid, TextField, Typography } from '@material-ui/core/';
import Link from 'next/link';
import React, { Fragment, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useAppConfig } from '~/hooks/useAppConfig.js';
import { login } from '../../store/legacy/actions/userActions.js';
import { getUserStore } from '../../store/legacy/selector/userSelectors';
import FacebookLoginButton from '../buttons/FacebookLoginButton';
import GoogleSignInButton from '../buttons/GoogleSignInButton.js';
import ChowbusForm from '../ChowbusForm';
import PasswordInput from '../ChowbusForm/PasswordInput';
import useStyles from './SignInForm.style.js';
import { isWeChatEnv, isAlipayEnv } from '../../utils/env.js'

const SignInForm = (props) => {
  const { onFacebookLogin, onGoogleLogin } = props;
  const { loginFailed } = useSelector(getUserStore);
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { isAlipay } = useAppConfig();
  const [isInWebView, setIsInWebView] = useState(false);

  const onSubmit = ({ email, password }) => {
    dispatch(login({ email, password }));
  };


  useEffect(() => {
    const isInWebView = isWeChatEnv() || isAlipayEnv();
    setIsInWebView(isInWebView);
  }, []);

  return (
    <Grid container justify='center' className={classes.formContainer}>
      <Typography variant='h5' align='center'>
        {intl.formatMessage({ id: 'form.sign-in.login.label' })}
      </Typography>
      <ChowbusForm.Form name='sign-in' onSubmit={onSubmit}>
        <ChowbusForm.Field name='email' required validate={ChowbusForm.validators.emailValidator}>
          {({ onChange, error }) => (
            <TextField
              label='Email'
              error={error}
              onChange={onChange}
              className={classes.formField}
              variant='outlined'
              fullWidth
              name='email'
            />
          )}
        </ChowbusForm.Field>
        <ChowbusForm.Field name='password' required>
          {({ onChange, error, errorMessage }) => (
            <PasswordInput
              label='Password'
              error={error}
              errorMessage={errorMessage}
              onChange={onChange}
              name='password'
            />
          )}
        </ChowbusForm.Field>
        <ChowbusForm.Field>
          {({ onSubmit, isValid }) => (
            <Button
              fullWidth
              variant='contained'
              color='primary'
              size='large'
              disabled={!isValid}
              className={classes.submitButton}
              onClick={onSubmit}>
              Sign In
            </Button>
          )}
        </ChowbusForm.Field>
        {!loginFailed && (
          <Typography align='center' variant='body2' style={{ marginTop: 20 }}>
            New to Chowbus?
            <Link href='/sign-up'>
              <a style={{ textDecoration: 'none', marginLeft: 10 }}>Create an account</a>
            </Link>
          </Typography>
        )}
        {loginFailed && (
          <Typography align='center' variant='body2' style={{ marginTop: 20 }}>
            Forgot password?
            <Link href='/reset-password'>
              <a style={{ textDecoration: 'none', marginLeft: 10 }}>Reset password</a>
            </Link>
          </Typography>
        )}
        {
          (!isAlipay && !isInWebView) && <React.Fragment>
            <Divider style={{ margin: '20px 0' }} />
            <Grid container justify='center' alignItems='center'>
              <Typography className={classes.orContinueWith}>or continue with</Typography>
              <FacebookLoginButton
                onFacebookLogin={onFacebookLogin}
                size={35}
                className={classes.orContinueWith}
                authAction='sign-in'
              />
              <GoogleSignInButton onGoogleLogin={onGoogleLogin} authAction='sign-in' />
            </Grid>
          </React.Fragment>
        }


      </ChowbusForm.Form>
    </Grid>
  );
};

export default SignInForm;
